import moment from 'moment';
import React from 'react';
import { useTranslation } from 'hooks/use-translation';
import { times } from 'utils/time-dates';
import { NumberSelect, OnDaySelector } from '../styles';

export const TimeSelector = ({ value, onChange }) => {
  const timeOfDayOptions = times().map((x) => ({
    value: x,
    label: moment(x, 'hh:mm').format('h:mm A'),
  }));

  const selectorLabel = useTranslation(
    'templates.status_updates.tab.config.freq.at_time',
  );

  const { value: val, label } = value;

  return (
    <OnDaySelector label={selectorLabel}>
      <NumberSelect
        options={timeOfDayOptions}
        value={{
          value: val,
          label,
        }}
        onChange={onChange}
      />
    </OnDaySelector>
  );
};
